import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appComponentValue]'
})
export class ComponentDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }

}
